export default __webpack_public_path__ + "static/planette-beige-28d8580859ccd35af715856b9af7e05f.svg";